import { publicClient, privateClient } from "../../configs/axiosConfig";

const menuEndpoints = {
  // =========================
  // 🍔 MENU ITEMS
  // =========================
  getAllMenuItems: "/v2/menu/items/food-items",
  getPublicMenuItems: "/v2/menu/items/getpublicfood",
  getMenuItemDetail: (id) => `/v2/menu/items/${id}`,
  createMenuItem: "/v2/menu/items",
  updateMenuItem: (id) => `/v2/menu/items/${id}`,
  deleteMenuItem: (id) => `/v2/menu/items/${id}`,

  // =========================
  // 📂 MENU CATEGORIES
  // =========================
  getAllMenuCategories: "/v2/menu/categories",
  getPublicMenuCategories: "/v2/menu/categories/getpublicmenu",
  getMenuCategoryById: (id) => `/v2/menu/categories/${id}`,

  createMenuCategory: "v2/menu/categories/create", // <-- adjust to match your backend route
  updateMenuCategory: "v2/menu/categories",
  deleteMenuCategory: "v2/menu/categories/delete",
};

const menuApi = {
  // =========================
  // 📂 CATEGORY
  // =========================
  getMenuCategories: async () => {
    try {
      const res = await privateClient.get(menuEndpoints.getAllMenuCategories);
      return res.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Get categories failed");
    }
  },

  getPublicMenuCategories: async () => {
    try {
      const res = await publicClient.get(menuEndpoints.getPublicMenuCategories);
      return res.data;
    } catch (err) {
      throw new Error(
        err.response?.data?.message || "Get public categories failed",
      );
    }
  },

  getMenuCategoryById: async (id) => {
    try {
      const res = await privateClient.get(
        menuEndpoints.getMenuCategoryById(id),
      );
      return res.data;
    } catch (err) {
      return { err };
    }
  },

  createMenuCategory: async (payload) => {
    try {
      const response = await privateClient.post(
        menuEndpoints.createMenuCategory,
        payload,
      );
      return { response };
    } catch (err) {
      console.log("err to create category");
      return { err };
    }
  },

  /** UPDATE category by id */
  updateMenuCategory: async ({ id, ...payload }) => {
    try {
      const response = await privateClient.patch(
        `${menuEndpoints.updateMenuCategory}/${id}`,
        payload,
      );
      return { response };
    } catch (err) {
      console.log("err to update category");
      return { err };
    }
  },
  /** Soft delete category: sets isDelete: "yes" on backend */

  deleteMenuCategory: async (id) => {
    try {
      const response = await privateClient.post(
        `${menuEndpoints.deleteMenuCategory}/${id}`,
      );
      return { response };
    } catch (err) {
      console.log("err to delete category");
      return { err };
    }
  },

  // =========================
  // 🍔 MENU ITEMS
  // =========================
  getMenuItemsActiveandInactive: async ({ operatorId }) => {
    try {
      const res = await privateClient.get(
        `${menuEndpoints.getAllMenuItems}?operatorId=${operatorId}`,
      );
      return res.data;
    } catch (err) {
      return { err };
    }
  },

  getPublicMenuItems: async () => {
    try {
      const res = await publicClient.get(menuEndpoints.getPublicMenuItems);
      return res.data;
    } catch (err) {
      return { err };
    }
  },

  getMenuItemDetail: async (id) => {
    try {
      const res = await privateClient.get(menuEndpoints.getMenuItemDetail(id));
      return res.data;
    } catch (err) {
      throw err;
    }
  },

  createMenuItem: async (payload) => {
    try {
      const res = await privateClient.post(
        menuEndpoints.createMenuItem,
        payload,
      );
      return res.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Create failed");
    }
  },

  updateMenuItem: async (id, data) => {
    try {
      const res = await privateClient.patch(
        menuEndpoints.updateMenuItem(id),
        data,
      );
      return res.data;
    } catch (err) {
      return { err };
    }
  },

  deleteMenuItem: async (id) => {
    try {
      const res = await privateClient.post(menuEndpoints.deleteMenuItem(id));
      return res.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Delete failed");
    }
  },
};

export default menuApi;
